import { format, isAfter, isBefore, isFuture, isSameHour, isSameMinute, isValid, parseISO, } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';
import { TIMEZONE } from '../../constants/timezone.js';
import { TODAYS_OPEN_STATUS } from '../../enums/index.js';
export const getStoreTimes = (storeTimes) => {
    const todayUTC = getTodayTimesUTC(storeTimes);
    const nextOpenDayUTC = getNextOpenDayUTC(storeTimes);
    const { timeTravelOverride } = storeTimes;
    const isNewStoreThatWillOpenSoon = storeTimes.storeDates.openingDate !== null && isFuture(storeTimes.storeDates.openingDate);
    const now = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    const willOpenLaterToday = todayUTC ? isBefore(now, todayUTC.openTime) : false;
    // isAfter doesn't handle the case where the current time is the exact same as the closing time
    // so checking if the hour and minute are the same as well
    const wasOpenEarlierToday = todayUTC
        ? isAfter(now, todayUTC.closeTime) ||
            (isSameHour(now, todayUTC.closeTime) && isSameMinute(now, todayUTC.closeTime))
        : false;
    const today = todayUTC ? convertToZonedTime(todayUTC) : null;
    const nextOpenDay = nextOpenDayUTC ? convertToZonedTime(nextOpenDayUTC) : null;
    const todaysOpenStatus = getTodaysOpenStatus(willOpenLaterToday, wasOpenEarlierToday);
    return {
        isNewStoreThatWillOpenSoon,
        today,
        nextOpenDay,
        todaysOpenStatus,
    };
};
const convertToZonedTime = (utcOpeningTimes) => {
    const openTime = fromUtcToZonedTime(utcOpeningTimes.openTime);
    const closeTime = fromUtcToZonedTime(utcOpeningTimes.closeTime);
    const pickupTime = fromUtcToZonedTime(utcOpeningTimes.pickupTime);
    return {
        date: utcOpeningTimes.date,
        openTime,
        closeTime,
        pickupTime,
    };
};
const getTodaysOpenStatus = (willOpenLaterToday, wasOpenEarlierToday) => {
    return willOpenLaterToday
        ? TODAYS_OPEN_STATUS.OPENING_LATER
        : wasOpenEarlierToday
            ? TODAYS_OPEN_STATUS.WAS_OPEN
            : TODAYS_OPEN_STATUS.OPEN_NOW;
};
const getTodayTimesUTC = (storeTimes) => {
    const today = getTodayFormattedDate(storeTimes.timeTravelOverride);
    const todaySchedule = storeTimes.schedules.find(schedule => schedule.scheduleDate === today);
    if (todaySchedule && !todaySchedule.isClosed) {
        const openTimeUTC = parseStoreTimeToUtc(todaySchedule.scheduleDate, todaySchedule.openTime);
        const closeTimeUTC = parseStoreTimeToUtc(todaySchedule.scheduleDate, todaySchedule.closeTime);
        const pickupTimeUTC = todaySchedule.pickupTime
            ? parseStoreTimeToUtc(todaySchedule.scheduleDate, todaySchedule.pickupTime)
            : openTimeUTC;
        return {
            date: today,
            openTime: openTimeUTC,
            closeTime: closeTimeUTC,
            pickupTime: pickupTimeUTC,
        };
    }
    else {
        return null;
    }
};
const getNextOpenDayUTC = (storeTimes) => {
    const today = getTodayFormattedDate(storeTimes.timeTravelOverride);
    const nextOpenSchedule = storeTimes.schedules
        .filter(schedule => {
        return schedule.scheduleDate > today && !schedule.isClosed;
    })
        .sort((a, b) => a.scheduleDate.localeCompare(b.scheduleDate))[0];
    if (!nextOpenSchedule) {
        return null;
    }
    const openTimeUTC = parseStoreTimeToUtc(nextOpenSchedule.scheduleDate, nextOpenSchedule.openTime);
    const closeTimeUTC = parseStoreTimeToUtc(nextOpenSchedule.scheduleDate, nextOpenSchedule.closeTime);
    const pickupTimeUTC = nextOpenSchedule.pickupTime
        ? parseStoreTimeToUtc(nextOpenSchedule.scheduleDate, nextOpenSchedule.pickupTime)
        : openTimeUTC;
    return {
        date: nextOpenSchedule.scheduleDate,
        openTime: openTimeUTC,
        closeTime: closeTimeUTC,
        pickupTime: pickupTimeUTC,
    };
};
// Go from UTC to zoned time to roll over to the next day if it's just before midnight
const getTodayFormattedDate = (timeTravelOverride) => {
    const now = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    return format(fromUtcToZonedTime(now), 'yyyy-MM-dd');
};
const parseStoreTimeToUtc = (dateStr, timeStr) => {
    const combinedStr = `${dateStr}T${timeStr}`;
    const localDate = parseISO(combinedStr);
    if (!isValid(localDate)) {
        console.error(`Invalid date or time format: ${combinedStr}`);
        return new Date();
    }
    return fromZonedTime(localDate, TIMEZONE);
};
const fromUtcToZonedTime = (date) => {
    return toZonedTime(date, TIMEZONE);
};
//# sourceMappingURL=getStoreTimes.js.map